import { useState } from 'react'
import { ListChecks } from 'lucide-react'
import { Button } from '@/components'
import { changesText, totalChanges, type WorkbenchUpdateSummary } from '../workbenchUpdate'
import WorkbenchChangesDialog from './WorkbenchChangesDialog'

interface WorkbenchChangesRowProps {
  summary: WorkbenchUpdateSummary
  /** A sent update's card: the dialog reads in the past tense. */
  sent?: boolean
}

/**
 * "Changes · drawings: 1 added, 2 edited  [View]" — the one line both the composer's
 * pending tab and a sent update's card carry. View lists the drawing changes, so it
 * is only offered when there are some. Its own button: it never sends anything.
 */
export default function WorkbenchChangesRow({ summary, sent = false }: WorkbenchChangesRowProps) {
  const [open, setOpen] = useState(false)
  const text = changesText(summary)
  const hasDrawingChanges = totalChanges(summary.counts) > 0
  return (
    <div className="flex items-center gap-2 min-w-0">
      <ListChecks size={14} strokeWidth={1.75} aria-hidden className="shrink-0 text-muted-foreground" />
      <span className="text-label text-foreground shrink-0">Changes</span>
      {text && <span className="text-caption text-muted-foreground truncate">· {text}</span>}
      {hasDrawingChanges && (
        <>
          <Button
            type="button"
            variant="outline"
            size="xs"
            className="ml-auto shrink-0"
            onClick={() => setOpen(true)}
            aria-label={summary.first ? 'View the drawings' : 'View the drawing changes'}
          >
            View
          </Button>
          <WorkbenchChangesDialog open={open} onOpenChange={setOpen} summary={summary} sent={sent} />
        </>
      )}
    </div>
  )
}
